
import React, { useState, useContext } from 'react';
import RecentTransaction from './Transact/components/RecentTransaction';
import MyResponsivePie from '.././Components/PieChart';
import { Select } from 'antd';
import { TrendingContext } from './context/TrendingContext';

import {
  DesktopOutlined,
  FileOutlined,
  PieChartOutlined,
  SettingOutlined,
  TransactionOutlined,
  MoneyCollectOutlined,
  ProfileOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Layout, Menu, theme } from 'antd';
import { Link } from 'react-router-dom';
import MyResponsiveBump from '../Components/Bump';
import MyResponsiveFunnel from '../Components/Funnel';
import LoadingRing from '../Components/LoadingRing';

// import { MyResponsivePie, Pie, PieCanvas, ResponsivePie, ResponsivePieCanvas, defaultProps, useNormalizedData, usePie, usePieArcs, usePieFromBox, usePieLayerContext } from '@nivo/pie'; // Add MyResponsivePie to the list of exports
const { Header, Content, Footer, Sider } = Layout;

const { Option } = Select;


function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}
const items = [
  getItem('Monitor', '2', <Link  ><DesktopOutlined /></Link>),
  getItem('Visualize', '1', <PieChartOutlined />, [getItem('Bitcoin', '5', <Link to='/coins/bitcoin'><MoneyCollectOutlined /></Link>),
  getItem('Ether', '5', <Link to='/coins/ethereum'><MoneyCollectOutlined /></Link>)]),
  getItem('User', 'sub1', <UserOutlined />,
    [
      getItem('Profile', '3', <ProfileOutlined />), getItem('File', '4', <FileOutlined />),
    ]
  ),
  getItem('Transaction', 'sub2', <TransactionOutlined />, [getItem('Track 1', '6'), getItem('Track 2', '8')]),
  getItem('Setting', '9', <SettingOutlined />),
];




const Dashboard = () => {


  const [collapsed, setCollapsed] = useState(false);
  const { trending } = useContext(TrendingContext);
  
  const [selectedComponent, setSelectedComponent] = useState("piechart");
  
  console.log("trendingcoinsDashboard", trending);

  
  const data = [];
  trending.map((ele) => {
    data.push({ id: ele.id.toUpperCase(), value: ele.current_price });

  })
  
  const datafunnel = trending.map((ele) => ({
    id: ele.id.toUpperCase(),
    value: ele.current_price,
    label: ele.name,
  }));

  const handleChange = (value) => {
    console.log(`selected ${value}`);
    setSelectedComponent(value);
  };
  const renderComponent = () => {
    switch (selectedComponent) {
      case "piechart":
        return <MyResponsivePie data={data} />;
      case "funnel":
        // return <MyResponsiveAreaBump data={data} />;
        return <MyResponsiveFunnel datafunnel={datafunnel} />
      case "line":
        return <div className='text-center font-3xl '>HeLLo Suyash...</div>;
      default:
        return <div className='text-center font-3xl '>Upadting Soon...</div>;
    }
  };

  const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();


  if(!trending||trending.length === 0)
  return( <LoadingRing/>);
  return (
    <Layout
      style={{
        minHeight: '100vh',
      }}
    >
      <Sider collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)}>
        <div className="demo-logo-vertical" />
        <Menu theme="dark" defaultSelectedKeys={['1']} mode="inline" items={items} />
      </Sider>
      <Layout>
        <Header
          style={{
            padding: 0,
            background: colorBgContainer,
          }}
        />
        <Content
          style={{
            margin: '0 16px',
          }}
        >
          <div
            style={{
              padding: 24,
              minHeight: 360,
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
            }}
          >
            <div className='h-[500px]'>
              <h1 className='font-2xl text-center text-3xl'>Trending Coins </h1>
              <Select
                defaultValue="piechart"
                style={{
                  width: 200,
                }}
                onChange={handleChange}
              >
                <Option value="piechart">Pie</Option>
                <Option value="funnel">Funnel</Option>
                <Option value="line">Line</Option>
              </Select>
              {renderComponent()}
              <br />
              <div className='border-b-4 border-indigo-500 my-9'></div>
            </div>
            <h1 className='my-9 text-3xl text-center text-blue-800'>Transaction on Blockchain</h1>
            <div className="flex flex-wrap justify-center items-center h-full text-richblack-100 text-3xl  shadow-lg rounded-md mt-8 ">
              <RecentTransaction />
            </div>
          </div>
        </Content>

        <Footer
          style={{
            textAlign: 'center',
          }}
        >
          CryptoVista ©{new Date().getFullYear()} Created by Suyash Singh
        </Footer>
      </Layout>
    </Layout>
  );
};
export default Dashboard;
